import React, { useState } from "react";
import Swal from "sweetalert2";
import img from "../../assets/support.jpg";
const CustomerServiceForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    description: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://e-training.ivorytraining.com/api/ar/customer-services", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const data = await response.json();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Form submitted successfully!",
          confirmButtonText: "موافق",
        });
        setFormData({ name: "", email: "", phone: "", description: "" }); // Reset form fields
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Error submitting the form. Please try again later.",
          confirmButtonText: "موافق",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while connecting to the API.",
        confirmButtonText: "موافق",
      });
      console.error(error);
    }
  };

  return (
    <div className="container">

      <div className="mt-4"
        style={{

          margin: "0 auto",
          padding: "10px",
          fontFamily: "Arial, sans-serif",
          border: "1px solid #ccc",
          borderRadius: "8px",
          backgroundColor: "#f9f9f9"
        }}
      >
        <h2 style={{ textAlign: "center", color: "#333" }}>تواصل مع الدعم الفنى</h2>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "15px" }}>
            <label style={{ display: "block", marginBottom: "5px", textAlign: "right" }}>الاسم</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "4px",
                border: "1px solid #ccc"
              }}
            />
          </div>
          <div style={{ marginBottom: "15px" }}>
            <label style={{ display: "block", marginBottom: "5px", textAlign: "right" }}>البريد الالكترونى</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "4px",
                border: "1px solid #ccc"
              }}
            />
          </div>
          <div style={{ marginBottom: "15px" }}>
            <label style={{ display: "block", marginBottom: "5px", textAlign: "right" }}>الجوال</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "4px",
                border: "1px solid #ccc"
              }}
            />
          </div>
          <div style={{ marginBottom: "15px" }}>
            <label style={{ display: "block", marginBottom: "5px", textAlign: "right" }}>الرساله</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                height: "120px"
              }}
            ></textarea>
          </div>
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "10px",
              backgroundColor: "#712",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "16px"
            }}
          >
            ارسال
          </button>
        </form>
      </div>

    </div>
  );
};

export default CustomerServiceForm;
